import React from 'react';
import PayrollRow from './PayrollRow';

const PayrollList = ({
    sortedPayrolls,
    payrolls,
    companies,
    units,
    employees,
    sortBy,
    setSortBy,
    canAddPayroll,
    canEditPayroll,
    canProcessPayroll,
    canDeletePayroll,
    handleAdd,
    handleEdit,
    handleProcess,
    handleDelete,
    getStatusBadge
}) => {
    return (
        <div className="row mb-4">
            <div className="col-12">
                <div className="card shadow-sm border-0">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="mb-0">
                                <i className="bi bi-calendar-range me-2"></i>
                                Payroll Periods
                            </h5>
                            <select
                                className="form-select w-auto"
                                value={sortBy}
                                onChange={(e) => setSortBy(e.target.value)}
                            >
                                <option value="month_year">Sort by Month-Year</option>
                                <option value="status">Sort by Status</option>
                                <option value="from_date">Sort by From Date</option>
                            </select>
                        </div>

                        {sortedPayrolls.length === 0 ? (
                            <div className="text-center py-5">
                                <i className="bi bi-calendar-range display-1 text-muted"></i>
                                <h4 className="mt-3 text-muted">No payroll periods found</h4>
                                <p className="text-muted">
                                    {payrolls.length === 0
                                        ? "No payroll periods scheduled. Add your first payroll period."
                                        : "No payroll periods match your search criteria."
                                    }
                                </p>
                                {payrolls.length === 0 && canAddPayroll && (
                                    <button
                                        className="btn btn-primary text-white mt-2"
                                        onClick={handleAdd}
                                    >
                                        <i className="bi bi-plus-circle me-2"></i>
                                        Add First Payroll Period
                                    </button>
                                )}
                            </div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="bg-light">
                                        <tr>
                                            <th className="ps-4">Month-Year</th>
                                            <th>Period</th>
                                            <th>Company/Unit</th>
                                            <th>Status</th>
                                            <th>Processed Info</th>
                                            <th className="text-end pe-4">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sortedPayrolls.map((payroll) => (
                                            <PayrollRow
                                                key={payroll.payroll_id}
                                                payroll={payroll}
                                                companies={companies}
                                                units={units}
                                                employees={employees}
                                                canEditPayroll={canEditPayroll}
                                                canProcessPayroll={canProcessPayroll}
                                                canDeletePayroll={canDeletePayroll}
                                                handleEdit={handleEdit}
                                                handleProcess={handleProcess}
                                                handleDelete={handleDelete}
                                                getStatusBadge={getStatusBadge}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PayrollList;